// App.tsx

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from '../styles/GlobalStyles';
import SettingsModal from './SettingsModal';
import HowToPlayModal from './HowToPlayModal';
import StatisticsModal from './StatisticsModal';
import { lightTheme, darkTheme } from '../styles/theme';
import Quiz from './Quiz';
import NavBar from './NavBar';
import { StatisticsProvider } from './StatisticsContext';

const App: React.FC = () => {
    const [theme, setTheme] = useState('light');
    const [showSettings, setShowSettings] = useState(false);
    const [showHowToPlay, setShowHowToPlay] = useState(false);
    const [showStatistics, setShowStatistics] = useState(false);

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
    };

    useEffect(() => {
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'dark') {
            setTheme('dark');
        }
    }, []);

    const currentTheme = theme === 'light' ? lightTheme : darkTheme;

    return (
        <ThemeProvider theme={currentTheme}>
            <GlobalStyles />
            <Router>
                    <StatisticsProvider>
                        <NavBar
                            onOpenSettings={() => setShowSettings(true)}
                            onOpenStatistics={() => setShowStatistics(true)}
                            onOpenHowToPlay={() => setShowHowToPlay(true)}
                        />
                        <Routes>
                            <Route path="/" element={<Quiz />} />
                            {/* Add other routes as needed */}
                        </Routes>
                        {showSettings && (
                            <SettingsModal
                                toggleTheme={toggleTheme}
                                onClose={() => setShowSettings(false)}
                            />
                        )}
                        {showHowToPlay && (
                            <HowToPlayModal onClose={() => setShowHowToPlay(false)} />
                        )}
                        {showStatistics && (
                            <StatisticsModal onClose={() => setShowStatistics(false)} />
                        )}
                    </StatisticsProvider>
            </Router>
        </ThemeProvider>
    );
};

export default App;
